export function debounce(fn, delay = 300) {
  let timeout

  return function (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}

export function throttle(fn, delay = 300) {
  let lastCall = 0

  return function (...args) {
    const context = this
    const now = Date.now()

    if (now - lastCall >= delay) {
      lastCall = now
      fn.apply(context, args)
    }
  }
}
